// Article status per retailer for the Insights page (2026-10-07). The backend returns each row's own code —
// PnP 04/05/62/72…, Checkers / MediRite / Petshop 1 / 0, Clicks A / N / I, Dis-Chem YES / NO from its
// ranging file. "Ranged" codes are the same lists as backend services/utilities/rangingStatus.js.
const PNP = {
  "04": ["Active / Listed", "green"],
  "05": ["New Article", "blue"],
  "07": ["Pending Delist", "yellow"],
  "60": ["Blocked", "red"],
  "61": ["Delisted - Store", "orange"],
  "62": ["Delisted - DC", "orange"],
  "70": ["Discontinued", "red"],
  "71": ["Discontinued - Phase Out", "red"],
  "72": ["Discontinued", "red"],
  "73": ["Discontinued - Return", "red"],
  "7C": ["Discontinued - Clearance", "purple"],
  "7E": ["Discontinued - Emergency", "red"],
}
const CHK = { "1": ["Ranged", "green"], "01": ["Ranged", "green"], "0": ["Not ranged", "orange"] }
const CLI = { A: ["Active", "green"], N: ["New", "blue"], I: ["Inactive", "red"], YES: ["Ranged", "green"], NO: ["Not ranged", "orange"] }
const DIS = { YES: ["Ranged", "green"], NO: ["Not ranged", "orange"] }
const RANGED = { PNP: ["04", "05", "4", "5"], CLI: ["A", "N", "YES"], CHK: ["1", "01"], DIS: ["YES"] }

const base = (retailer) => {
  const r = String(retailer || "").toUpperCase()
  return r === "MED" || r === "PET" ? "CHK" : r
}
const table = (retailer) => ({ PNP, CHK, CLI, DIS }[base(retailer)] || DIS)

export const statusLabel = (code, retailer) =>
  code === "unknown" ? "No status" : (table(retailer)[String(code).toUpperCase()] || [`Status ${code}`])[0]
export const statusColor = (code, retailer) =>
  code === "unknown" ? "gray" : (table(retailer)[String(code).toUpperCase()] || [null, "gray"])[1]
export const isRangedStatus = (code, retailer) => (RANGED[base(retailer)] || ["YES"]).includes(String(code).toUpperCase())
